<nav
  class="admin-sidebar"
  [class.is-expanded]="sidebarExpanded()"
  aria-label="Primary navigation"
  (mouseenter)="setSidebarExpanded(true)"
  (mouseleave)="setSidebarExpanded(false)"
  (pointerdown)="onSidebarPointerDown()"
  (focusin)="onSidebarFocusIn($event)"
  (focusout)="onSidebarFocusOut($event)"
>
  @for (group of menuGroups(); track group.id) {
    <section
      class="menu-group"
      routerLinkActive="has-active"
      [class.collapsed]="isGroupCollapsed(group.id)"
      [attr.data-group]="group.id"
    >
      <button class="menu-group-header" type="button" (click)="toggleGroup(group.id)">
        <span class="menu-group-title">
          <span>{{ group.label }}</span>
          <span class="active-dot"></span>
        </span>
        <span class="group-chev" aria-hidden="true"></span>
      </button>

      <div class="menu-group-items">
        @for (item of group.items; track item.routerLink) {
          <!-- The tooltip is only for the icon rail at rest; expanded sidebars already show labels. -->
          <a
            class="sidebar-menu-item"
            [routerLink]="item.routerLink"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
            [attr.aria-label]="item.label"
            [appTooltip]="sidebarItemTooltip(item.label)"
            tooltipPosition="right"
            [tooltipSingleLine]="true"
          >
            <span
              class="menu-icon"
              [class.quick-books-icon]="item.quickBooksIcon"
              [class.menu-icon-orders]="item.iconName === 'orders'"
              [class.menu-icon-invoices]="item.iconName === 'invoices'"
              [class.menu-icon-rental-machines]="item.iconName === 'rental-machines'"
              [class.menu-icon-rentals]="item.iconName === 'rentals'"
              [class.menu-icon-service-slips]="item.iconName === 'service-slips'"
              [class.menu-icon-products]="item.iconName === 'products'"
              [class.menu-icon-pricing-groups]="item.iconName === 'pricing-groups'"
              [class.menu-icon-transfers]="item.iconName === 'transfers'"
              [class.menu-icon-customers]="item.iconName === 'customers'"
              [class.menu-icon-reps]="item.iconName === 'reps'"
              [class.menu-icon-admins]="item.iconName === 'admins'"
              [class.menu-icon-territories]="item.iconName === 'territories'"
              [class.menu-icon-reports]="item.iconName === 'reports'"
              [class.menu-icon-manual-invoice-sync]="item.iconName === 'manual-invoice-sync'"
            >
              @if (item.quickBooksIcon) {
                <span aria-hidden="true"></span>
              }
            </span>
            <span class="menu-label">{{ item.label }}</span>
          </a>
        }
      </div>
    </section>
  }
</nav>
